import { HttpClient } from '@angular/common/http';
import { GlobalsService } from './globals.service';
import { BaseProvider } from './base-provider';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./globals.service";
export class ProfileTypeService extends BaseProvider {
    constructor(http, globals) {
        super();
        this.http = http;
        this.globals = globals;
        this.baseUrl = 'profileType';
    }
    getProfileTypes() {
        return this.http.get(this.globals.dataUrl + this.baseUrl);
    }
}
ProfileTypeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProfileTypeService_Factory() { return new ProfileTypeService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.GlobalsService)); }, token: ProfileTypeService, providedIn: "root" });
